module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0123.jpg?v=209e3659";